import { action, makeObservable, observable } from 'mobx'

import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import { IFilters } from '~/client/src/shared/stores/InitialState'
import BaseLogisticsMapStore from '~/client/src/shared/stores/ui/BaseLogisticsMap.store'
import {
  createFilterValueByType,
  getSelectedFilterValues,
} from '~/client/src/shared/utils/logisticsHelper'
import { UNASSIGNED } from '~/client/src/shared/utils/ZoneLevelLocationConstants'

import MobileLogisticsStore from './MobileLogistics.store'

export default class MobileLogisticsMapStore extends BaseLogisticsMapStore {
  @observable public isFiltersModalOpen: boolean = false

  public constructor(
    store: MobileLogisticsStore,
    companiesStore: CompaniesStore,
  ) {
    super(store, companiesStore)
    makeObservable(this)
  }

  @action.bound
  public toggleFilters() {
    this.isFiltersModalOpen = !this.isFiltersModalOpen
  }

  protected get filter(): IFilters {
    return this.store.filters
  }

  private get filterValueByType() {
    return createFilterValueByType(
      this.store.getSharedFormById,
      () => this.store.state.activeProject.id,
    )
  }

  public getFilteredCollectionExcludeFilter = (
    excludedFilters: Array<string> = [],
  ) => {
    let filteredCollection = this.isSearchFilterActive
      ? this.instancesInPeriodInterval.filter(this.searchFiltering)
      : this.instancesInPeriodInterval

    this.activeFilterTypes.forEach(filterType => {
      const shouldUseFilter = !excludedFilters.includes(filterType)

      if (!shouldUseFilter) {
        return
      }

      const filter = this.filter.fieldsMap[filterType]
      const { initialFilterOptions } = filter
      const selectedValues = getSelectedFilterValues(
        filterType,
        initialFilterOptions,
      )

      filteredCollection = filteredCollection.filter(inst => {
        const valueGetter = this.filterValueByType[filterType]
        const value = valueGetter(inst)

        if (initialFilterOptions.has(UNASSIGNED) && !value.length) {
          return true
        }

        return value.some(v => selectedValues.has(v))
      })
    })

    return filteredCollection
  }
}
